import { render } from "./BlogCategoryPage.vue?vue&type=template&id=2602f2c0"
import script from "./BlogCategoryPage.vue?vue&type=script&lang=js"
export * from "./BlogCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__